jQuery(document).on('ready', function () {
  jQuery('.footer-logo-container > a, div.logo > a').on('click', function (e) {
    e.preventDefault()

    return false
  })

  jQuery('form#create_customer').submit(function (event) {
    event.preventDefault()
    const data = jQuery(this).serialize()

    jQuery('.js-form-error-notification').addClass('display-none')
    jQuery('.js-registration-leon-button').attr('disabled' , true)

    jQuery.post('/account', data)
      .done(function (response) {
        const logErrors = jQuery(response).find('.errors').text()

        if (logErrors != "" && logErrors != 'undefined') {
          jQuery('.js-form-error-notification').removeClass('display-none')
        } else {
          document.location.href = '/'
        }

        jQuery('.js-registration-leon-button').attr('disabled' , false)
      }).fail(function () {
        jQuery('.js-registration-leon-button').attr('disabled' , false)
      })

    return false
  })
})
